export default __webpack_public_path__ + "static/media/spa-img-18.943be078.png";